export const getIsAnchorLink = (url: string) => {
  if (!url) return false
  return url.startsWith('#')
}
